// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"button_PrimaryButton__GWuyM","cancelButton":"button_cancelButton__E6c5V","deleteBtn":"button_deleteBtn__Vbxz-"};